import { isElement, forEach } from 'lodash';
import containerManager from '../../01-helpers/filter-context/container-manager';
import { get as getPageOptions } from '../../01-helpers/utilities/options';
import { subscribe } from '../../01-helpers/event-manager';

import { FILTERAPI_FAILED } from '../../02-const/event-names';

const moduleName = 'filter-counter',
    selectors = {
        base: `.js-${moduleName}`
    },
    translationsKey = {
        key: 'translations',
        results: 'Results',
        result: 'Result'
    };


export default class FilterCounter {

    constructor(baseElement) {
        if (!isElement(baseElement)) {
            return false;
        }

        this._configure(baseElement);
        this._setup();
    }

    _clearCounter() {
        this.baseElement.innerHTML = `- ${this.translations[translationsKey.results]}`;
    }

    _updateCounter(currentState) {
        const count = currentState?.response?.TotalResults;
        this.baseElement.innerHTML = `${count} ${count > 1 ? this.translations[translationsKey.results] : this.translations[translationsKey.result] }`;
    }

    _bindEvents() {
        this.filterContext.onUpdate(({ currentState }) => this._updateCounter(currentState));
        subscribe(FILTERAPI_FAILED, this._clearCounter.bind(this));
    }

    /**
     * configure the class
     * @param {any} baseElement
     */
    _configure(baseElement) {
        this.baseElement = baseElement;
        this.filterContext = containerManager.getContainer();
    }

    _setup() {
        this.translations = getPageOptions(translationsKey.key);
        this._bindEvents();
    }
}

/* ========================================================================== */

const initFilterCounter = () => {
    forEach(document.querySelectorAll(selectors.base), (counterElement) => {
        new FilterCounter(counterElement);
    });
};

initFilterCounter();